import { useState } from 'react'
import Swal from 'sweetalert2'
import KampanieService from '@/services/KampanieService'

export default function useKampanieModal(loadData) {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editingItem, setEditingItem] = useState(null)
	const [formName, setFormName] = useState('')
	const [formDescription, setFormDescription] = useState('')
	const [isSaving, setIsSaving] = useState(false)

	const resetForm = () => {
		setFormName('')
		setFormDescription('')
	}

	const openEditModal = item => {
		setEditingItem(item)
		setFormName(item?.nazwa || '')
		setFormDescription(item?.description ?? '')
		setIsModalOpen(true)
	}

	const closeModal = () => {
		setIsModalOpen(false)
		setEditingItem(null)
		resetForm()
		setIsSaving(false)
	}

	const handleSubmit = async e => {
		e.preventDefault()
		const nazwa = formName.trim()
		if (!nazwa) return

		setIsSaving(true)
		if (!editingItem?._id) return

		const result = await KampanieService.update(editingItem._id, {
			nazwa,
			description: formDescription.trim(),
		})

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie zapisac kampanii',
				icon: 'error',
			})
			setIsSaving(false)
			return
		}

		closeModal()
		await loadData()
	}

	const handleDelete = async item => {
		const confirm = await Swal.fire({
			title: 'Czy na pewno?',
			text: `Usunac kampanie "${item?.nazwa || '-'}"?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Tak, usun',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		const result = await KampanieService.delete(item?._id)
		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie usunac kampanii',
				icon: 'error',
			})
			return
		}

		await loadData()
	}

	return {
		isModalOpen,
		editingItem,
		formName,
		setFormName,
		formDescription,
		setFormDescription,
		isSaving,
		openEditModal,
		handleDelete,
		closeModal,
		handleSubmit,
	}
}
